import { pushEvent } from '../../../client/data-layer';
import { OptionTypeEnum } from 'src/components/filter-dropdown';

// Tracks when the user changes a filter for the offerlist
export const trackPriceListFilterUpdate = (
  selectedFilter: string,
  checked: boolean
) => {
  pushEvent('priceListFilterUpdate', { selectedFilter, checked });
};

type ProductSizeVariantClickoutData = {
  isVariantFiltered: boolean;
  isPrimaryList: boolean;
};

export const trackProductSizeVariantClickout = (
  data: ProductSizeVariantClickoutData
) => {
  pushEvent('productSizeVariantClickout', data);
};

export const trackPriceListOfferSortingChange = (
  productId: number,
  sorting: OptionTypeEnum
) => {
  pushEvent('offerSorting', { productId, sorting });
};

export const trackUnfeaturedPlaceholderClick = (productId: number) =>
  pushEvent('productUnfeaturedPlaceholderClicked', { productId });

export const trackUnfeaturedHideClick = (productId: number) =>
  pushEvent('productUnfeaturedHideClicked', { productId });
